import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FormModal from 'components/reusable/modals/FormModal'

const Label = styled.label`
  display: grid;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
  color: #4b6176;
`

const Select = styled.select`
  border: 1px solid #bec8d3;
  border-radius: 4px;
  height: 38px;
  padding: 0 10px;
  background: #f0f3f6;
`

const Input = styled.input`
  border: 1px solid #bec8d3;
  border-radius: 4px;
  height: 38px;
  padding: 0 10px;
  background: #f0f3f6;
`

const ErrorMeta = styled.div`
  margin-top: 8px;
  color: #9f1f1f;
  background: #fdeaea;
  border: 1px solid #f3b7b7;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 12px;
`

const AddProductVariantModal = ({
  open,
  productOptions,
  variantProductId,
  variantName,
  formError,
  onChangeProductId,
  onChangeName,
  onClose,
  onSubmit,
  lockProduct,
}) => {
  if (!open) return null

  return (
    <FormModal
      open={open}
      title="Add Variant"
      onClose={onClose}
      onConfirm={onSubmit}
      confirmLabel="Create"
      cancelLabel="Cancel"
      width="480px"
      actionsAlign="right"
      closeControl="glyph"
    >
      <Label>
        Product *
        <Select value={variantProductId} onChange={event => onChangeProductId(event.target.value)} disabled={lockProduct}>
          <option value="">Select product</option>
          {productOptions.map(item => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </Select>
      </Label>
      <Label>Variant SKU<Input value="Auto-generated by backend" disabled /></Label>
      <Label>Variant Name<Input value={variantName} onChange={event => onChangeName(event.target.value)} /></Label>
      <Label>QR Code<Input value="Auto-generated by backend" disabled /></Label>
      {formError && <ErrorMeta>{formError}</ErrorMeta>}
    </FormModal>
  )
}

AddProductVariantModal.propTypes = {
  open: PropTypes.bool.isRequired,
  productOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  variantProductId: PropTypes.string.isRequired,
  variantName: PropTypes.string.isRequired,
  formError: PropTypes.string.isRequired,
  onChangeProductId: PropTypes.func.isRequired,
  onChangeName: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  lockProduct: PropTypes.bool,
}

AddProductVariantModal.defaultProps = {
  lockProduct: false,
}

export default AddProductVariantModal
